export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
            <div className="flex-1 w-full max-w-[480px]">
              <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20digital%20news%20aggregation%20platform%20abstract%20illustration%2C%20warm%20dark%20background%20with%20coral%20and%20amber%20accents%2C%20entertainment%20media%20concept%2C%20editorial%20design%20style%2C%20clean%20modern%20composition%2C%20professional%20newsroom%20aesthetic%2C%20information%20flow%20visualization&width=960&height=720&seq=about-718-01&orientation=landscape"
                  alt="黑料718品牌介绍"
                  title="黑料718 - 关于我们"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            <div className="flex-1 w-full">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-4">
                关于黑料718
              </h2>
              <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                <p>
                  黑料718成立于2024年，是专注于娱乐八卦和热门黑料聚合的内容平台。我们以「让吃瓜更简单」为使命，通过技术手段和编辑团队的专业筛选，为吃瓜群众提供最新鲜、最全面的娱乐资讯体验。
                </p>
                <p>
                  平台每日追踪明星动态、综艺内幕、网红翻车、音乐八卦、体育花边等十二大领域的热门话题，所有内容经过多渠道交叉验证后方可发布，确保信息准确性。目前，黑料718已累计收录数万条热门黑料，日均服务超过百万吃瓜群众。
                </p>
                <p>
                  无论你是偶尔吃瓜的路人，还是深耕娱乐八卦的资深瓜友，黑料718都能满足你对每日新鲜黑料的一站式浏览需求。我们始终相信，吃瓜不仅是一种娱乐方式，更是了解当下流行文化和社会热点的重要窗口。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}